import React from "react";
import placeholderuser from '../../assets/images/userplaceholder.webp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
const Newlinkedinpost = () => {

    return (
        <div className="newuser-container">
            <p className="newuser-title fb-campaign-tittle">Add Linkedin Post</p>
            <div className="newuser-form-box">


                <div className="newuser-form">
                    <div className="newuser-field">
                        <label>What do you want to talk about?</label>
                        <textarea
                            name="postText"
                            rows={4}
                            placeholder="Start typing your post..."
                        />

                    </div>
                    <div className="newuser-field">
                        <label>Upload Image or Video</label>
                        <input type="file" name="media" accept="image/*,video/*" />

                    </div>
                    <div className="newuser-field">
                        <label>Event Title</label>
                        <input
                            type="text"
                            name="eventTitle"
                            placeholder="e.g. Webinar, Hiring Drive"
                        />



                    </div>
                    <div className="newuser-field">
                        <label>Event Date</label>
                        <input
                            type="datetime-local"
                            name="eventDate"
                        />

                    </div>
                    <div className="newuser-field">
                        <label>Tags / Hashtags</label>
                        <input
                            type="text"
                            name="tags"
                            placeholder="#marketing #job"
                        />

                    </div>


                   

                </div>
                <div className="newuser-form">

                <div className="newuser-field">
                        <label>Location</label>
                        <input
                            type="text"
                            name="location"
                            placeholder="e.g. Mumbai, India"
                        />


                    </div>

                    <div className="newuser-field">
                        <label>Target Audience Country</label>
                        <input
                            type="text"
                            name="targetCountry"
                            placeholder="e.g. United States"
                        />

                    </div>
                    <div className="newuser-field">
                        <label>Schedule Date & Time</label>
                        <input
                            type="datetime-local"
                            name="scheduleDate"
                        />


                    </div>
                    <div className="newuser-field">
                        <label>
                            <input
                                type="checkbox"
                                name="publishNow"
                            />{" "}
                            Publish Now
                        </label>

                    </div>


                    <div className="newuser-field">
                        <label>
                            <input
                                type="checkbox"
                                name="isHiring"
                            />{" "}
                            Mark as Hiring Post
                        </label>


                    </div>

                   

                    <div className='mb-2'>
                        <button type="submit  " className="btn btn-primary newuser-btn">  Save</button>

                    </div>
                </div>
            </div>
        </div>
    )
};
export default Newlinkedinpost